export function isFunction(obj: any): obj is (...args: any[]) => any {
  return typeof obj === 'function';
}
